/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChatMessage } from './ChatMessage';
import {
    ChatMessageFromJSON,
    ChatMessageFromJSONTyped,
    ChatMessageToJSON,
    ChatMessageToJSONTyped,
} from './ChatMessage';

/**
 * Basic serializer for Chats.
 * @export
 * @interface PatchedChat
 */
export interface PatchedChat {
    /**
     * 
     * @type {number}
     * @memberof PatchedChat
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedChat
     */
    name?: string;
    /**
     * 
     * @type {Array<ChatMessage>}
     * @memberof PatchedChat
     */
    readonly messages?: Array<ChatMessage>;
    /**
     * 
     * @type {Date}
     * @memberof PatchedChat
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PatchedChat
     */
    readonly updatedAt?: Date;
}

/**
 * Check if a given object implements the PatchedChat interface.
 */
export function instanceOfPatchedChat(value: object): value is PatchedChat {
    return true;
}

export function PatchedChatFromJSON(json: any): PatchedChat {
    return PatchedChatFromJSONTyped(json, false);
}

export function PatchedChatFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedChat {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'messages': json['messages'] == null ? undefined : ((json['messages'] as Array<any>).map(ChatMessageFromJSON)),
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
    };
}

  export function PatchedChatToJSON(json: any): PatchedChat {
      return PatchedChatToJSONTyped(json, false);
  }

  export function PatchedChatToJSONTyped(value?: Omit<PatchedChat, 'id'|'messages'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

